
import type { Reducer, Effect } from 'umi';
import { getRoleList } from '@/services/role';

export type Item = {
    id?: string;
    name?: string;
}

export type RoleModelState = {
  allRoleList: Item[]
}

export type RoleModelType = {
  namespace: string;
  state: RoleModelState;
  effects: {
    getRoleList: Effect;
  };
  reducers: {
    changeRoleList: Reducer<RoleModelState>;
  };
}

const Model: RoleModelType = {
  namespace: 'role',
  state: {
    allRoleList: [],
  },

  effects: {
    *getRoleList({ payload }, { call, put }) {
      const response = yield call(getRoleList, payload);
      if(response.code === 0) {
        yield put({type:"changeRoleList",payload:response.data});
      }
    },
  },

  reducers: {
    changeRoleList(state, { payload }) {
        return {
        ...state,
        allRoleList:payload
        };
    },
  },
};

export default Model;
